import { useMutation } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useGlobal } from "@/app/store/global"
import { postLogin } from "@/entities/auth/api/post-login.ts"
import { prefetchMe } from "@/features/auth/api/use-fetch-me.ts"
import { Auth } from "@/shared/lib"
import { Notice } from "@/shared/utils/notice.tsx"

export const usePostLogin = () => {
  // Helpers
  const navigate = useNavigate()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: postLogin,
    onSuccess: async data => {
      Auth.setToken(data.access, { expires: 1 })
      Auth.setRefreshToken(data.refresh, { expires: 7 })
      prefetchMe()
      useGlobal.saveUser(data.user)
      navigate("/dashboard", { replace: true })
    },
    onError: (err: unknown) => {
      console.log(err)
      Notice.error((err as { data: { detail: string } })?.data?.detail ?? t("login-error"))
    }
  })
}
